import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

function renderDropDown(props, ref) {
  let link = ''
  if (props.link === 'javascript:;') {
    link = <a className={`${props.aClasses} ${props.id}`} id={props.id} href="javascript:;" onClick={(e) => {
      props.onClick()
      ref.props.toggleWithId(e)
    }} >{props.name}</a>
  } else {
    link = <NavLink
      id={props.id}
      className={`${props.aClasses} ${props.id}`}
      to={props.link}
      exact={true}
      activeClassName={props.active ? props.activeClass : null}
      onClick={ref.props.toggleWithId}>
      {props.name}
    </NavLink>
  }

  return (<li key={props.id} className={`${props.listClasses}`}>{link}</li>)
}

class DropdownListItems extends React.Component {
  renderChildren(item) {
    return renderDropDown(Object.assign({...item}, {
      listClasses: 'dropdown-list-item',
      activeClass: 'dropdown-item-link-active',
      aClasses: 'dropdown-item-link'
    }), this)
  }

  render() {
    const {dropdown} = this.props
    return (
      <ul id={dropdown} className="dropdown-items">
        {this.props.navList.map(this.renderChildren.bind(this))}
      </ul>
    )
  }
}

DropdownListItems.propTypes = {
  id: PropTypes.string.isRequired,
  toggleWithId: PropTypes.func.isRequired,
  dropdown: PropTypes.string,
  navList: PropTypes.array.isRequired
}

export default DropdownListItems



// WEBPACK FOOTER //
// ./assets/js/helpers/DropdownListItems.jsx